import { IPrismicCardsColumnItem, ICardsColumn, IItem } from './types';

export const mapCardsColumn = ({ prismicContent }): ICardsColumn => {
  const items: IItem[] = prismicContent.items.map(
    (item: IPrismicCardsColumnItem) => {
      return {
        cardImage: item.card_image,
        cardImageMobile: item.card_image_mobile,
        cardLink: item.card_link,
        cardText: item.card_text,
        backgroundColor: item.background_color,
      };
    },
  );

  const CardsColumn: ICardsColumn = {
    title: prismicContent.primary.title1,
    titleIcon: prismicContent.primary.title_icon,
    items,
  };

  return CardsColumn;
};
